import { Buffer } from 'buffer';
import JSZip from 'jszip';
import { offlineData } from '../configs/offlineData';
import { UserTypes } from '../constants/constant';

export const isNullEmptyOrUndefined = (value) => value === null || value === '' || value === undefined || value.length === 0;

export const userData = () => (localStorage.getItem('userData') !== 'undefined' ? JSON.parse(localStorage.getItem('userData'))
  : {
    competitorAdmin: null,
    isOfUserType: null,
    superAdmin: null,
    isSuperAdmin: false,
    isValidUserAccessRole: false,
    units: [],
    userId: '',
    userName: '',
  });

export const isIos = () => userData()?.isOfUserType === UserTypes.IoS;

export const isRu = () => userData()?.isOfUserType === UserTypes.RU;

export const isSu = () => userData()?.isOfUserType === UserTypes.SU;

export const capitalizeFirstLetter = (string) => string.charAt(0).toUpperCase() + string.slice(1);

export const isNullEmptyUndefinedOrZero = (value) => isNullEmptyOrUndefined(value) || value === 0 || value === '0';

export const isNullEmptyUndefinedOrZeroWithDot = (value) => isNullEmptyOrUndefined(value) || value === 0 || value === '0' || value === '0.' || value === '0.0' || value === '.' || value === '.0';

export const userRu = () => (localStorage.getItem('selectedRetailUnit') ? JSON.parse(localStorage.getItem('selectedRetailUnit'))?.ruCode : null);

export const userRuDetails = () => (localStorage.getItem('selectedRetailUnit') ? JSON.parse(localStorage.getItem('selectedRetailUnit')) : null);

export const userRefRu = () => (localStorage.getItem('selectedRetailUnit') ? JSON.parse(localStorage.getItem('selectedRetailUnit'))?.refRuCode
  || JSON.parse(localStorage.getItem('selectedRetailUnit'))?.ruCode : null);

export const checkIsCountrySpecific = () => {
  if (isIos()) return false;
  return true;
};

export const checkCompetitorAdmin = (storedRuCode, competitorAdmin) => {
  const competitor = competitorAdmin.find((item) => item.key === storedRuCode);
  return competitor?.value ?? false;
};

export const isValidUrl = (urlString) => {
  let url;
  try {
    url = new URL(urlString);
  } catch (e) {
    return false;
  }
  return url.protocol === 'http:' || url.protocol === 'https:';
};

export const projectType = () => {
  let prjType;
  if (isIos()) prjType = 0;
  else if (isRu()) prjType = 1;
  else if (isSu()) prjType = 2;
  else prjType = null;
  return prjType;
};

export const userType = () => {
  let prjType;
  if (isIos() || isRu()) prjType = 1;
  else prjType = 2;
  return prjType;
};

export const isLocalHost = () => {
  const isLocal = window.location.hostname === 'localhost';
  return isLocal;
};

export const fetchSelectedHfbOffline = () => offlineData.getItem('selectedHfbs').then((data) => data);

export const fetchSelectedRuOffline = () => offlineData.getItem('selectedRetailUnit').then((data) => data?.ruCode);

export const getFullUrl = (url) => {
  if (url && !url.startsWith('http://') && !url.startsWith('https://')) {
    return `https://${url}`;
  }
  return url;
};

export const env = () => {
  const { hostname } = window.location;

  const prodAuth = 'https://ingka-icow-prod.eu.auth0.com';
  const nonProdAuth = 'https://ingka-icow-test.eu.auth0.com';
  const stageAuth = 'https://ingka-icow-stag.eu.auth0.com';

  const sharedProd = {
    cId: 'zyFns1rMZuz5d8nCgoHjG2FyUFoKlWq4',
    authUrl: prodAuth,
    audience: `${prodAuth}/api/v2/`,
    logoutUrl: `${prodAuth}/oidc/logout?federated`,
    scope: 'openid profile email offline_access',
  };

  const sharedStage = {
    cId: 'CeWqeURFowifLoZUUVeLuoe7URtEKVw1',
    authUrl: stageAuth,
    audience: `${stageAuth}/api/v2/`,
    logoutUrl: `${stageAuth}/oidc/logout?federated`,
    scope: 'openid profile email offline_access',
  };

  const sharedNonProd = {
    cId: 'BmLlbyQtX3VPnoIdfU8ph0DKqFwxrxwh',
    authUrl: nonProdAuth,
    audience: `${nonProdAuth}/api/v2/`,
    logoutUrl: `${nonProdAuth}/oidc/logout?federated`,
    scope: 'openid profile email offline_access',
  };

  const isDev = hostname.includes('frontend-dev');
  const isQa = hostname.includes('frontend-qa');

  if (isDev) {
    return { ...sharedNonProd, baseUrl: 'https://api.inter.ikeadt.net/cbr/ram/tocompete/backend-dev/' };
  }
  if (isQa || hostname.includes('localhost')) {
    // return { ...sharedNonProd, baseUrl: 'http://localhost:7071/api/' };
    return { ...sharedNonProd, baseUrl: 'https://api.inter.ikeadt.net/cbr/ram/tocompete/backend-qa/' };
  }
  return { ...sharedProd, baseUrl: 'https://api.inter.ikea.net/cbr/ram/tocompete/backend-prod/' };
};

export const notificationUrls = (userID = '') => {
  const testBaseUrl = 'https://notification-api.inter.ikeadt.net/';
  const prodBaseUrl = 'https://notification-api.inter.ikea.net/';
  const { hostname } = window.location;
  let baseUrl = prodBaseUrl;
  let notificationHighlight = `${prodBaseUrl}/sdf/api/release-content/v1/release-content/GetNotificationHighlight?userId=${userID || userData()?.userId}&appCode=ToCompete`;
  let popupDisplay = `${prodBaseUrl}/sdf/api/release-content/v1/release-content/GetPopupNotification?userId=${userID || userData()?.userId}&appCode=ToCompete`;
  let updateHighlight = `${prodBaseUrl}sdf/api/release-content/v1/release-content/UpdateNotification?userId=${userID || userData()?.userId}&appCode=ToCompete&type=widget`;
  let notificationSideBar = `${prodBaseUrl}sdf/api/release-note/v1/release-notes?appCode=ToCompete&userId=${userID || userData()?.userId}&type=widget`;
  let notificationPopup = `${prodBaseUrl}sdf/api/release-note/v1/release-notes?appCode=ToCompete&userId=${userID || userData()?.userId}&type=popup`;
  let notificationPopupClose = `${prodBaseUrl}sdf/api/release-content/v1/release-content/ClosePopup?appCode=ToCompete&userId=${userID || userData()?.userId}`;
  let notificationDismiss = `${prodBaseUrl}/sdf/api/release-content/v1/release-content/DismissNotification?appCode=ToCompete&userId=${userID || userData()?.userId}&rcno=`;
  let notifMediaToken = `${prodBaseUrl}/sdf/api/release-content/v1/blobstorage/OAuthToken`;
  let notifCenterToken = `${prodBaseUrl}/sdf/api/release-content/v1/notification-center/GetToken?appName=ToCompete`;
  let notifCenterUrl = 'https://notification-center.inter.ikea.net/?appCode=';
  if (hostname.includes('test')
    || hostname === 'localhost'
    || hostname.includes('qa')
    || hostname.includes('dev')
    || hostname === 'app.tocomp.np.apaas.inter.ikea.net'
  ) {
    baseUrl = testBaseUrl;
    notificationHighlight = `${testBaseUrl}/sdf/api/release-content/v1/release-content/GetNotificationHighlight?userId=${userID || userData()?.userId}&appCode=ToCompete`;
    popupDisplay = `${testBaseUrl}/sdf/api/release-content/v1/release-content/GetPopupNotification?userId=${userID || userData()?.userId}&appCode=ToCompete`;
    updateHighlight = `${testBaseUrl}sdf/api/release-content/v1/release-content/UpdateNotification?userId=${userID || userData()?.userId}&appCode=ToCompete&type=widget`;
    notificationSideBar = `${testBaseUrl}sdf/api/release-note/v1/release-notes?appCode=ToCompete&userId=${userID || userData()?.userId}&type=widget`;
    notificationPopup = `${testBaseUrl}sdf/api/release-note/v1/release-notes?appCode=ToCompete&userId=${userID || userData()?.userId}&type=popup`;
    notificationPopupClose = `${testBaseUrl}sdf/api/release-content/v1/release-content/ClosePopup?appCode=ToCompete&userId=${userID || userData()?.userId}`;
    notificationDismiss = `${testBaseUrl}/sdf/api/release-content/v1/release-content/DismissNotification?appCode=ToCompete&userId=${userID || userData()?.userId}&rcno=`;
    notifMediaToken = `${testBaseUrl}/sdf/api/release-content/v1/blobstorage/OAuthToken`;
    notifCenterToken = `${testBaseUrl}/sdf/api/release-content/v1/notification-center/GetToken?appName=ToCompete`;
    notifCenterUrl = 'https://notification-center.inter.ikeadt.net/?appCode=';
  }
  return {
    notificationHighlight,
    popupDisplay,
    updateHighlight,
    notificationSideBar,
    notificationPopup,
    notificationPopupClose,
    notificationDismiss,
    notifMediaToken,
    notifCenterToken,
    notifCenterUrl,
    prodBaseUrl,
    baseUrl,
  };
};

export const convertUnit = (type, value) => {
  if (type === 'kg' || type === 'l' || type === 'pc' || type === 'lb') {
    return value;
  } if (type === 'oz') {
    return value / 16; // ounce to pound
  } if (type === 'cl') {
    return value / 100; // cl to liter
  } if (type === 'gallon') {
    return value * 3.785; // gallon to liter
  } if (type === 'fl.oz') {
    return value / 33.814; // fl ounce to liter
  }
  return value / 1000; // g || ml to kg or l
};

export const convertToBase64 = (val) => {
  if (!isNullEmptyOrUndefined(val)) {
    const stringValue = typeof val === 'object' ? JSON.stringify(val) : val;
    return Buffer.from(stringValue).toString('base64');
  }
  return null;
};

export const removeLogoutOfflineData = () => {
  localStorage.clear();
  sessionStorage.clear();
  offlineData.removeItem('projectData');
  offlineData.removeItem('selectedHfbs');
  offlineData.removeItem('selectedRetailUnit');
  offlineData.removeItem('userDetails');
  offlineData.removeItem('userRetailUnits');
  offlineData.removeItem('competitorsList');
};

export const setLogoutOfflineData = () => {
  localStorage.setItem('loggedInOnce', 'true');
  localStorage.setItem('loggedOut', 'true');
};

export const compressJson = (data) => new Promise((resolve, reject) => {
  const zip = new JSZip();
  zip.file('data.json', JSON.stringify(data));
  // Generate the zip file
  zip.generateAsync({
    type: 'blob',
    compression: 'DEFLATE',
    compressionOptions: {
      level: 9,
    },
  })
    .then((content) => resolve(content))
    .catch((err) => reject(err));
});

export const getBase64 = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result);
  reader.onerror = (error) => reject(error);
});

export const roundQtyToTwoDecimalPlaces = (value) => {
  const match = value.match(/^(\d+(\.\d+)?)\s*(\w+)$/);

  if (!match) {
    throw new Error('Invalid input format');
  }

  const number = parseFloat(match[1]);
  const unit = match[3];

  // If the unit is "pc", return the original string
  if (unit === 'pc') {
    return value;
  }

  // Otherwise, round the number to 2 decimal places and return the formatted string
  const roundedNumber = number.toFixed(2);
  return `${roundedNumber} ${unit}`;
};
